// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"af5a1942","760":"485db23c"}[chunkId] + ".chunk.js";
};